export default __webpack_public_path__ + "static/media/overlay.cb8ff19f.svg";